<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router'

  defineProps<{
    to: RouteLocationRaw,
  }>()
</script>

<template>
  <div>
    <router-link
      :to="to"
      class="menu-item">
      <slot></slot>
    </router-link>
  </div>
</template>

<style  scoped>
@reference "@/assets/styles/main.css";
.menu-item {
  @apply block p-2  text-gray-900 rounded;
  @apply hover:bg-gray-50 break-words;
}
</style>
